'use client';

import React from 'react';
import ExportReport from './ExportReport';
import VotesReports from './VotesReports';
import Fieldset from '~/components/commonUi/Fieldset';
import { observer } from 'mobx-react';
import { getStore } from '~/mobx/AppStore';
interface Props {
    userVoteFromStand: number;
    userVoteFromWeb: number;
}

const SlagReports = (props: Props) => {
    const { userVoteFromStand, userVoteFromWeb } = props;

    return (
        <div className="slag-reports mb-4">
            <div className="overflow-x-auto">
                <Fieldset title={'STEMMER VED VALG (S-Lag)'}>
                    <VotesReports userVoteFromStand={userVoteFromStand} userVoteFromWeb={userVoteFromWeb} />
                </Fieldset>
            </div>
            <ExportReport />
        </div>
    );
};

const SlagReportsWithStore = () => {
    const { reportStore } = getStore();

    return (
        <SlagReports userVoteFromStand={reportStore?.userCount?.stand} userVoteFromWeb={reportStore?.userCount?.web} />
    );
};

export default observer(SlagReportsWithStore);
